import axios from 'axios'

export const createContact = body =>
  axios.post('/api/contact', body).then(({ data }) => data)

export default {
  createContact
}
